import { useEffect, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { generatePath, useRouteMatch } from 'react-router';
import { push } from 'redux-first-history';
import { safelyDecodeBase64Url, safelyEncodeBase64Url } from '@dev/ee-tools';
import { ApplicationState } from '@/store';
import { GetCampaignByName } from '@/store/campaigns/actions';
import { CampaignsPaths } from '@/services/dictionaries/Paths';

export const useCampaignReportRedirectFromBackend = () => {
    const { campaigns } = useSelector((state: ApplicationState) => state);
    const { pickedCampaign } = campaigns;
    const { isExact: isPathExact, params } =
        useRouteMatch<{ name: string }>(CampaignsPaths.CampaignReport_BackendLinkInEmail) || {};
    const dispatch = useDispatch();
    const { campaign } = pickedCampaign;

    const base64decodedName = safelyDecodeBase64Url(params?.name);
    const decodedName = base64decodedName === params?.name ? decodeURIComponent(params?.name) : base64decodedName;
    useLayoutEffect(() => {
        if (!isPathExact) return;
        dispatch(
            GetCampaignByName({
                name: decodedName,
            })
        );
    }, []);

    useEffect(() => {
        if (!isPathExact) return;
        const base64encode = base64decodedName === params?.name ? safelyEncodeBase64Url(decodedName) : params?.name;

        if (campaign?.Type) {
            const newPath = generatePath(CampaignsPaths.CampaignOverview, { name: base64encode, type: campaign.Type });
            dispatch(push(newPath));
        }
    }, [campaign?.Type]);

    return isPathExact;
};
